export enum StaticFileModule {
  INVEST_COMBINATIONS = "invest-combinations",
}
